import { ProductOrderItem } from '@mews-commander/types';
import { ProductOrder } from './types';

export const createProductOrder = (orderItem: ProductOrderItem): ProductOrder => {
    const {
        id,
        isCanceled,
        billId,
        accountingState,
        nightMultiplier,
        unitMultiplier,
        personMultiplier,
        productChargingMode,
        unitAmount,
        consumedUtc,
        data,
        ownerId,
    } = orderItem;

    return {
        id,
        isCanceled,
        billId,
        accountingState,
        multipliers: {
            night: nightMultiplier,
            unit: unitMultiplier,
            person: personMultiplier,
        },
        charging: productChargingMode,
        consumptionUtc: consumedUtc,
        unitAmount,
        data,
        ownerId,
    } as ProductOrder;
};
